export default {
  incorrectAddressWarning: {
    en: "Please enter a correct address",
    ja: "正しい住所を入力してください"
  },
  walletPlaceholder: {
    en: "Wallet address",
    ja: "ウォレットアドレス"
  },
  title: {
    en: "Payment Method",
    ja: "支払方法"
  },
  verified: {
    en: "Verified",
    ja: "検証済み"
  },
  unverified: {
    en: "Unverified",
    ja: "未確認"
  },
  currentlyConnected: {
    en: "Currently connected",
    ja: "現在接続中"
  },
  addWalletButton: {
    en: "Add",
    ja: "追加"
  },
  copied:{
    en: 'Copied',
    ja: 'コピー機'
  },
}
